var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFeedback40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speech-bubble",
    transform: "translate(5.625000, 10.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125,6 L28.125,17.3 C28.125,17.8522847 27.6772847,18.3 27.125,18.3 L24.4886364,18.3 L24.4886364,18.3 L24.4583333,22.5 L20.8522727,18.3 L9.125,18.3 C8.57271525,18.3 8.125,17.8522847 8.125,17.3 L8.125,6 C8.125,5.44771525 8.57271525,5 9.125,5 L27.125,5 C27.6772847,5 28.125,5.44771525 28.125,6 Z",
    id: "Speech-bubble-recieve",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.00080553 C0,0.448075896 0.455305576,0 0.99180311,0 L19.0081969,0 C19.5559546,0 20,0.447889475 20,1.00080553 L20,12.4607329 C20,13.0134626 19.5470296,13.4615385 19.0013123,13.4615385 L7.27272727,13.4615385 L3.66666667,17.5 L3.66666667,13.4615385 L1.00193278,13.4615385 C0.448580585,13.4615385 0,13.013649 0,12.4607329 L0,1.00080553 Z",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFeedback40);
export default __webpack_public_path__ + "static/media/pictogramBeaconFeedback40.90cc1d72b54c9e81c2ab6043db63a374.svg";
export { ForwardRef as ReactComponent };